import { Component, OnInit, ElementRef, ViewChild, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { WizardHpBaseComponent } from 'projects/hp-api/src/lib/base/wizard/wizard-hp-base-component';
import { HpService } from 'projects/hp-api/src/lib/services/hp.service';
import { InfosComponent } from '../dialogs/infos/infos.component';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent extends WizardHpBaseComponent {
  
  constructor(chgDetectorRef: ChangeDetectorRef, hpService: HpService, router: Router,public dialog: MatDialog,
    private elRef: ElementRef) {
      super(chgDetectorRef, hpService, router);

  }

  ngOnInit() {
    super.ngOnInit();
  }

  public toRouter(link_: string, i: number) {
    if (this.getHpService().getCurrentPage() < i) {
      return;
    }
    this.getHpService().setCurrentProductIndex(0); 
    this.getHpService().setshowMenuWindows(false);
    
    this.getRouter().navigate([link_]);
  }

  openDialogInfo(demande: string) {


    const dialogRef = this.dialog.open(InfosComponent, {
      panelClass: 'full-width-dialog-info',
      data: { name: demande }
    });


    dialogRef.afterClosed().subscribe(result => {

    });

  }
}
